
export function replaceParts(string, parts = []) {
    
    if (typeof string !== 'string' || string == null || string == '' || !Array.isArray(parts) || parts.length === 0)
        return string;
    
    let result = string;

    parts.forEach(part => {
        if (Array.isArray(part) && part.length == 2) {
            const regex = new RegExp(part[0], 'g');
            result = result.replace(regex, part[1]);
        }
    });
    
    return result;
}